<script lang="ts" setup>
import StaticSupportPage from './Content.vue'
</script>

<template>
    <StaticSupportPage />
</template>
